/**
 * FinanceApp - Copyright (c) 2026 Emmanuel TESTE
 * Tous droits réservés - Logiciel propriétaire
 */
export const THEMES = {
  light: {
    '--bg-primary':    '#F8F9FC',
    '--bg-secondary':  '#FFFFFF',
    '--bg-card':       '#FFFFFF',
    '--bg-sidebar':    '#1E2433',
    '--text-primary':  '#1A1D2E',
    '--text-secondary':'#374151',   // amélioré : 10.7:1 sur blanc (WCAG AAA)
    '--text-muted':    '#6B7280',   // amélioré : 4.75:1 sur blanc (WCAG AA)
    '--border':        '#E5E7EB',
    '--accent':        '#1a9e72',
    '--accent-hover':  '#0f6e56',
    '--accent-light':  '#f0fdf4',
    '--success':       '#10B981',
    '--warning':       '#F59E0B',
    '--danger':        '#EF4444',
    '--info':          '#3B82F6',
    '--shadow':        '0 1px 3px rgba(0,0,0,0.1)',
    // Rétrocompatibilité
    '--bg':            '#F8F9FC',
    '--card-bg':       '#FFFFFF',
    '--text':          '#1A1D2E',
    '--text-hint':     '#6B7280',
    '--g':             '#1a9e72',
    '--sidebar-bg':         '#1E2433',
    '--sidebar-text':        '#94a3b8',
    '--sidebar-active-bg':   '#1a9e72',
    '--sidebar-active-text': '#FFFFFF',
    '--sidebar-hover':       'rgba(26,158,114,0.15)',
    '--sidebar-border':      'rgba(255,255,255,0.09)',
    // Badges — WCAG AA (ratio ≥ 4.5:1) en mode clair
    '--badge-success-bg':   '#ECFDF5',
    '--badge-success-text': '#065F46',
    '--badge-warning-bg':   '#FFFBEB',
    '--badge-warning-text': '#92400E',
    '--badge-danger-bg':    '#FEF2F2',
    '--badge-danger-text':  '#991B1B',
    '--badge-info-bg':      '#EFF6FF',
    '--badge-info-text':    '#1E40AF',
    '--badge-accent-bg':    '#EEF2FF',
    '--badge-accent-text':  '#3730A3',
    '--badge-neutral-bg':   '#F3F4F6',
    '--badge-neutral-text': '#374151',
  },
  dark: {
    '--bg-primary':    '#0F1117',
    '--bg-secondary':  '#1A1D2E',
    '--bg-card':       '#1E2433',
    '--bg-sidebar':    '#13151F',
    '--text-primary':  '#F9FAFB',
    '--text-secondary':'#D1D5DB',
    '--text-muted':    '#94A3B8',   // amélioré : plus lisible sur fond sombre
    '--border':        '#2D3348',
    '--accent':        '#6366F1',
    '--accent-hover':  '#818CF8',
    '--accent-light':  '#1E1B4B',
    '--success':       '#10B981',
    '--warning':       '#F59E0B',
    '--danger':        '#EF4444',
    '--info':          '#3B82F6',
    '--shadow':        '0 1px 3px rgba(0,0,0,0.3)',
    // Rétrocompatibilité
    '--bg':            '#0F1117',
    '--card-bg':       '#1E2433',
    '--text':          '#F9FAFB',
    '--text-hint':     '#94A3B8',
    '--g':             '#6366F1',
    '--sidebar-bg':         '#13151F',
    '--sidebar-text':        '#94a3b8',
    '--sidebar-active-bg':   '#6366F1',
    '--sidebar-active-text': '#FFFFFF',
    '--sidebar-hover':       'rgba(99,102,241,0.15)',
    '--sidebar-border':      'rgba(255,255,255,0.08)',
    // Badges — lisibles sur fond sombre
    '--badge-success-bg':   'rgba(16,185,129,0.18)',
    '--badge-success-text': '#34D399',
    '--badge-warning-bg':   'rgba(245,158,11,0.18)',
    '--badge-warning-text': '#FCD34D',
    '--badge-danger-bg':    'rgba(239,68,68,0.18)',
    '--badge-danger-text':  '#F87171',
    '--badge-info-bg':      'rgba(59,130,246,0.18)',
    '--badge-info-text':    '#60A5FA',
    '--badge-accent-bg':    'rgba(99,102,241,0.18)',
    '--badge-accent-text':  '#818CF8',
    '--badge-neutral-bg':   'rgba(107,114,128,0.18)',
    '--badge-neutral-text': '#D1D5DB',
  },
};
